import type { AjudaDaPagina, ChaveDePagina } from "./tipos";
import { AJUDA_DA_CLINICA } from "./paginas-clinica";
import { AJUDA_DO_LABORATORIO } from "./paginas-laboratorio";
import { AJUDA_DA_CONTA } from "./paginas-conta";
import { AJUDA_DAS_CONFIGURACOES } from "./paginas-configuracoes";

// Um arquivo por domínio; o tipo completo aqui faz o typecheck acusar chave sem texto.
export const AJUDA_DAS_PAGINAS: Record<ChaveDePagina, AjudaDaPagina> = {
  ...AJUDA_DA_CLINICA,
  ...AJUDA_DO_LABORATORIO,
  ...AJUDA_DA_CONTA,
  ...AJUDA_DAS_CONFIGURACOES,
};
